export function decodeJWT(token) {


  if (!token) {
    return null;
  }

  const base64UrlDecode = (str) => {
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
    return JSON.parse(atob(padded));
  };

  const [header, payload, signature] = token.split('.');

  return {
    header: base64UrlDecode(header),
    payload: base64UrlDecode(payload),
    signature,
  };
}
